






import { Component, Vue } from 'vue-property-decorator';
import Navigation from '@/components/Navigation.vue';

@Component({
  components: {
    Navigation,
  },
})
export default class Left extends Vue {
  public mounted() {
    // console.log(this.$store.state.documents);
    // this.$store.dispatch('requestData');
  }
}
